module.exports = __webpack_public_path__ + "static/ClickedYes-3ef29edf9e57e630600881732e15e694.png";